import { useLocation } from '@reach/router';
import { CONST } from 'constants/enums';
import { PERM, PERM_CONTEXT } from 'utils/can';

import { getWindowUser } from './storage/storageGets';

export const getPermContext = pathname => {
	if(pathname.includes(`/${PERM_CONTEXT.ADW}`)) {
		return PERM_CONTEXT.ADW;
	} else if(pathname.includes(`/${PERM_CONTEXT.UAXB}`)) {
		return PERM_CONTEXT.UAXB;
	} else if(pathname.includes(`/${PERM_CONTEXT.ADX}`)) {
		return PERM_CONTEXT.ADX;
	} else if(pathname.includes(`/${PERM_CONTEXT.UAX}`)) {
		return PERM_CONTEXT.UAX;
	}  else if(pathname.includes(`/${PERM_CONTEXT.KAP}`)) {
		return PERM_CONTEXT.KAP;
	}
	return PERM_CONTEXT.CMN;
};

export const getSlugAgreement = (pathname, context) => {
	if(pathname) {
		const firstCharPos = pathname.lastIndexOf(`/${context}/`) + 2 + context.length;
		const lastSlashPos = pathname.lastIndexOf('/');
		const lastCharPos = firstCharPos > lastSlashPos ? pathname.length : lastSlashPos;

		const path = pathname.substring(firstCharPos, lastCharPos);

		let splitPath = path;

		if(path.includes('/')) {
			splitPath = path.split('/')[0];
		}

		if(splitPath !== CONST.ALL_SLUG_ROUTE && splitPath.length > 8) {
			// slug have to minimum 9 char
			return splitPath;
		}
	}
	return null;
};

export default function usePermContext() {
	const { agreement } = getWindowUser();
	const location = useLocation();

	const context = getPermContext(location.pathname);
	const isSingleObject = PERM.IS_ANIMATOR() || context === PERM_CONTEXT.ADW;
	const subject = PERM.IS_ANIMATOR() ? agreement.slug : context;
	const slugAgreement = PERM.IS_ANIMATOR() ? agreement.slug : getSlugAgreement(location.pathname, context);

	return {
		context,
		subject,
		slugAgreement,
		isSingleObject,
	};
}
